// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9175c6df","453":"aaa6ff49"}[chunkId] + ".chunk.js";
};